import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-wizard-user",
  templateUrl: "./wizard-user.component.html",
  styleUrls: ["./wizard-user.component.scss"],
  standalone: false,
})
export class WizardUserComponent {
  constructor(private router: Router) {}

  submitted = (user: Record<string, unknown>) =>
    void this.router.navigate(["wizard/final"], {
      state: { internal: { user } },
    });
}
